import api from "../api";
import UIComponent from "../ui/component";

export class TranscriptionsBulkActions extends UIComponent {
    init() {
        this.includeComponents({
            transcriptionsList:"document@[data-tbx-component=TranscriptionsList]",
            ConfirmDeleteModal: "document@#ConfirmDeleteModal",
            moveModal: "document@#moveModal",
        });

        this.selectedCounts = this.find("#selectedCount");
        this.setupEventHandlers();
    }

    setupEventHandlers() {
        this.transcriptionsList.on("selectionChange", () => {
            this.updateBulkActionsPanel();
        });

        this.bulkDeleteBtn?.on("click", () => {
            const selectedIds = this.getSelectedIds();
            if (selectedIds.length === 0) return;

            this.ConfirmDeleteModal.on("bulkDeleteSuccess", () => {
                this.transcriptionsList.selectedItems = {};
                this.updateBulkActionsPanel();
                window.location.reload();
            });

            this.ConfirmDeleteModal.show("bulk_file", selectedIds);
        });

        this.bulkMoveBtn?.on("click", async () => {
            const selectedIds = this.getSelectedIds();
            if (selectedIds.length === 0) {
                return;
            }
            try {
                this.moveModal?.open(selectedIds, true);
            } catch (error) {
                console.error("Error loading folders:", error);
            }
        });
    }

    getSelectedIds() {
        return Object.keys(this.transcriptionsList.selectedItems);
    }

    updateBulkActionsPanel() {
        const count = Object.keys(this.transcriptionsList.selectedItems).length;
        if (this.selectedCounts) {
            this.selectedCounts.textContent = count.toString();
        }
        if (count > 0) {
            this.show();
        } else {
            this.hide();
        }
    }

    // setupBulkActionsPosition() {
    //     const footer = document.querySelector("#pagination");

    //     const updateFixedPosition = () => {
    //         const parentRect =
    //             this.element.parentElement.getBoundingClientRect();
    //         this.element.style.left =
    //             parentRect.left + parentRect.width / 2 + "px";
    //     };

    //     const observer = new IntersectionObserver(
    //         (entries) => {
    //             entries.forEach((entry) => {
    //                 if (entry.isIntersecting) {
    //                     this.addClass("bulk-sticky");
    //                     this.removeClass("bulk-fixed");
    //                     updateFixedPosition();
    //                 } else {
    //                     this.addClass("bulk-fixed");
    //                     this.removeClass("bulk-sticky");
    //                     updateFixedPosition();
    //                 }
    //             });
    //         },
    //         {
    //             threshold: 0.1,
    //             rootMargin: `0px 0px 15px 0px`,
    //         }
    //     );

    //     observer.observe(footer);

    //     window.addEventListener("scroll", updateFixedPosition);
    //     window.addEventListener("resize", updateFixedPosition);
    // }
}
